export const ARTIFACT_NAME='???';
export const LOCKED_SECRET_MESSAGE='THE ARTIFACT OF ??? DOES NOT YET HAVE THIS ABILITY';
export const STARTING_STARS=3;

// Camps are data, not one-off UI state. Later climbers can raise shaftCost and
// grant a different piece of climbing equipment without changing the cave flow.
export const CLIMBER_CAMPS=[{
  id:'quarry-refuge',afterLevel:0,shaftCost:3,
  climber:{name:'The first climber',condition:'dirty and exhausted'},
  item:{key:'field_brace',name:'Field brace',detail:'Reinforce the most strained surviving connection once per climb.'},
  arrival:'He has been camped beside the dead lift for longer than he will say.',
  offer:'“Three stars will wake the shaft. Get me home, and the brace is yours. I won’t be needing it.”',
}];

export const SECRET_SITES=[{
  id:'quarry-seal',campId:'quarry-refuge',requiredAbility:'awaken-seals',
  label:'A sealed mark is cut into the cave wall.',
}];

export function emptyStory(){return{spentStars:0,rescues:{},inventory:[],artifact:{abilities:['open-old-stone']},seenSecrets:[]};}
export function normalizeStory(value){
  const out=emptyStory();if(!value||typeof value!=='object')return out;
  out.spentStars=Number.isInteger(value.spentStars)&&value.spentStars>=0?value.spentStars:0;
  for(const camp of CLIMBER_CAMPS)if(value.rescues?.[camp.id]===true)out.rescues[camp.id]=true;
  out.inventory=[...new Set((Array.isArray(value.inventory)?value.inventory:[]).filter(key=>CLIMBER_CAMPS.some(c=>c.item.key===key)))];
  const allowed=new Set(['open-old-stone','awaken-seals']);
  out.artifact.abilities=[...new Set((Array.isArray(value.artifact?.abilities)?value.artifact.abilities:[]).filter(a=>allowed.has(a)))];
  if(!out.artifact.abilities.includes('open-old-stone'))out.artifact.abilities.unshift('open-old-stone');
  out.seenSecrets=[...new Set((Array.isArray(value.seenSecrets)?value.seenSecrets:[]).filter(id=>SECRET_SITES.some(s=>s.id===id)))];
  return out;
}
export function availableStars(save,earned){return Math.max(0,STARTING_STARS+earned-(save.story?.spentStars||0));}
export function hasItem(save,key){return save?.story?.inventory?.includes(key)===true;}
export function rescueClimber(save,campId,earned){
  const camp=CLIMBER_CAMPS.find(c=>c.id===campId);if(!camp)return{ok:false,reason:'missing'};
  if(save.story.rescues[campId])return{ok:true,already:true,camp};
  if(availableStars(save,earned)<camp.shaftCost)return{ok:false,reason:'stars',camp};
  save.story.spentStars+=camp.shaftCost;save.story.rescues[campId]=true;
  if(!save.story.inventory.includes(camp.item.key))save.story.inventory.push(camp.item.key);
  return{ok:true,already:false,camp};
}
export function inspectSecret(save,secretId){
  const secret=SECRET_SITES.find(s=>s.id===secretId);if(!secret)return{open:false,message:''};
  if(!save.story.seenSecrets.includes(secretId))save.story.seenSecrets.push(secretId);
  const open=save.story.artifact.abilities.includes(secret.requiredAbility);
  return{open,message:open?'THE SEAL AWAKENS':LOCKED_SECRET_MESSAGE,secret};
}
